import { createContext } from 'react';

/**
 * Bridges the tree-wide handlers (rename, link edit, create, delete, collapse…)
 * down to each dnd-kit row without prop-drilling. Provided by MenuAdminTree,
 * consumed by MenuDndItemComponent.
 */
export const MenuTreeCtx = createContext(null);
